<template>
  <transition :name="modalTransition">
    <div
      v-show="value"
      ref="modalBackground"
      class="modal fullscreen flex"
      :class="modalClasses"
      @click="click($event)"
      @mousedown="lock($event)"
    >
      <div ref="content"
      class="modal-content scroll"
      :class="contentClasses">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
// import Platform from '../../features/platform'
// import EscapeKey from '../../features/escape-key'
// import Utils from '../../utils'

const positions = {
  top: 'items-start justify-center with-backdrop',
  bottom: 'items-end justify-center with-backdrop',
  right: 'items-center justify-end with-backdrop',
  left: 'items-center justify-start with-backdrop'
}
const positionCSS = {
  mat: {
    maxHeight: '80vh',
    height: 'auto'
  },
  ios: {
    maxHeight: '80vh',
    height: 'auto',
    boxShadow: 'none'
  }
}

function additionalCSS (theme, position) {
  let css = {}

  if (['left', 'right'].includes(position)) {
    css.maxWidth = '90vw'
  }
  if (theme === 'ios') {
    if (['left', 'top'].includes(position)) {
      css.borderTopLeftRadius = 0
    }
    if (['right', 'top'].includes(position)) {
      css.borderTopRightRadius = 0
    }
    if (['left', 'bottom'].includes(position)) {
      css.borderBottomLeftRadius = 0
    }
    if (['right', 'bottom'].includes(position)) {
      css.borderBottomRightRadius = 0
    }
  }

  return css
}

let
  duration = 200, // in ms -- synch with transition CSS from Modal
  openedModalNumber = 0

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: '',
      validator (val) {
        return val === '' || ['top', 'bottom', 'left', 'right'].includes(val)
      }
    },
    transition: {
      type: String,
      default: 'q-modal'
    },
    positionClasses: {
      type: String,
      default: 'items-center justify-center'
    },
    contentClasses: [Object, String],
    contentCss: [Object, String],
    noBackdropDismiss: {
      type: Boolean,
      default: false
    },
    noEscDismiss: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      locked: false
    }
  },
  computed: {
    modalClasses () {
      return this.position ? positions[this.position] : this.positionClasses
    },
    modalTransition () {
      return this.position ? `q-modal-${this.position}` : this.transition
    }
  },
  methods: {
    open (onShow) {
      if (this.value) {
        return
      }
      // document.body.appendChild(this.$el)

      // this.active = true
      this.$emit('input', true)

      // setTimeout(() => {
      //   if (typeof onShow === 'function') {
      //     onShow()
      //   }
      //   this.$emit('open')
      // }, duration)
    },
    close (onClose) {
      if (!this.value) {
        return
      }
      // this.active = false
      this.$emit('input', false)
      if (typeof onClose === 'function') {
        onClose()
      }
      // this.__onClose = onClose
    },
    lock (e) {
      if (e.target === this.$refs.modalBackground) {
        this.locked = true
      }
    },
    click (e) {
      if (this.noBackdropDismiss) {
        return
      }
      if (e.target !== this.$refs.modalBackground) {
        return
      }
      if (!this.locked) {
        return
      }
      this.locked = false
      this.close()
    }
  },
  beforeDestroy () {
    if (this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  mounted () {
    document.body.appendChild(this.$el)
  }
}
</script>
<style>
.modal-content {
  position: relative;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 14px 28px rgba(0, 0, 0, .25), 0 10px 10px rgba(0, 0, 0, .22);
  overflow-y: auto;
  min-width: 280px;
  max-height: 80vh;
  height: auto;
}
.modal-content .layout {
  width: 100%;
  height: 100%
}
.modal {
  z-index: 200
}
.modal.minimized,
.modal.with-backdrop {
  background: rgba(0, 0, 0, .4)
}
.modal.minimized .modal-content {
  max-width: 80vw;
  max-height: 80vh
}
.modal.maximized .modal-content {
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  border-radius: 0
}
.q-modal-enter,
.q-modal-leave-active {
  opacity: 0
}
@media screen and (min-width: 601px) {
  .modal:not(.maximized) {
    background: rgba(0, 0, 0, .4)
  }
  .modal:not(.maximized).q-modal-enter .modal-content {
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
  }
  .modal:not(.maximized).q-modal-leave-active .modal-content {
    -webkit-transform: scale(.8);
    transform: scale(.8)
  }
  .modal.maximized.q-modal-enter .modal-content,
  .modal.maximized.q-modal-leave-active .modal-content {
    -webkit-transform: translateX(101%);
    transform: translateX(101%)
  }
}
@media screen and (max-width: 600px) {
  .modal:not(.minimized) .modal-content {
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
    border-radius: 0
  }
  .modal:not(.minimized).q-modal-enter .modal-content,
  .modal:not(.minimized).q-modal-leave-active .modal-content {
    -webkit-transform: translateX(101%);
    transform: translateX(101%)
  }
  .modal.minimized.q-modal-enter .modal-content {
    -webkit-transform: scale(1.2);
    transform: scale(1.2)
  }
  .modal.minimized.q-modal-leave-active .modal-content {
    -webkit-transform: scale(.8);
    transform: scale(.8)
  }
}
.modal,
.modal-content {
  transition: all .2s ease-in-out
}
.modal-header {
  text-align: left;
  padding: 24px 24px 20px;
  font-size: 1.6rem;
  font-weight: 500
}
.modal-body {
  padding: 0 24px 24px
}
.modal-body {
  text-align: left;
  color: rgba(0, 0, 0, .5)
}
.big-modal-scroll,
.modal-scroll,
.small-modal-scroll {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  /*will-change: scroll-position*/
}
.small-modal-scroll {
  max-height: 156px
}
.modal-scroll {
  max-height: 240px
}
.big-modal-scroll {
  max-height: 480px
}
.modal-buttons {
  padding: 8px 8px 12px 24px;
  -webkit-box-pack: end;
  -ms-flex-pack: end;
  justify-content: flex-end
}
.modal-buttons.column {
  -webkit-box-align: end;
  -ms-flex-align: end;
  align-items: flex-end
}

.q-modal-bottom-enter,
.q-modal-bottom-leave-active,
.q-modal-top-enter,
.q-modal-top-leave-active,
.q-modal-right-enter,
.q-modal-right-leave-active,
.q-modal-left-enter,
.q-modal-left-leave-active {
  opacity: 0
}
.q-modal-bottom-enter .modal-content,
.q-modal-bottom-leave-active .modal-content {
  -webkit-transform: translateY(101%);
  transform: translateY(101%)
}
.q-modal-top-enter .modal-content,
.q-modal-top-leave-active .modal-content {
  -webkit-transform: translateY(-101%);
  transform: translateY(-101%)
}
.q-modal-right-enter .modal-content,
.q-modal-right-leave-active .modal-content {
  -webkit-transform: translateX(101%);
  transform: translateX(101%)
}
.q-modal-left-enter .modal-content,
.q-modal-left-leave-active .modal-content {
  -webkit-transform: translateX(-101%);
  transform: translateX(-101%)
}

.modal.is-big .modal-content {
  width: 80%;
  height: 80%;
}

.modal.is-half .modal-content {
  width: 50%;
  height: 80%;
}
/*
//BULMA

.modal-background {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  background-color: rgba(10, 10, 10, 0.86);
}

.modal-content,
.modal-card {
  margin: 0 20px;
  max-height: calc(100vh - 160px);
  overflow: auto;
  position: relative;
  width: 100%;
}

@media screen and (min-width: 769px), print {
  .modal-content,
  .modal-card {
    margin: 0 auto;
    max-height: calc(100vh - 40px);
    width: 640px;
  }
}

.modal-close {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  background-color: rgba(10, 10, 10, 0.2);
  border: none;
  border-radius: 290486px;
  cursor: pointer;
  display: inline-block;
  -webkit-box-flex: 0;
      -ms-flex-positive: 0;
          flex-grow: 0;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  font-size: 1rem;
  height: 20px;
  max-height: 20px;
  max-width: 20px;
  min-height: 20px;
  min-width: 20px;
  outline: none;
  position: relative;
  vertical-align: top;
  width: 20px;
  background: none;
  height: 40px;
  position: fixed;
  right: 20px;
  top: 20px;
  width: 40px;
}

.modal-close:before, .modal-close:after {
  background-color: white;
  content: "";
  display: block;
  left: 50%;
  position: absolute;
  top: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%) rotate(45deg);
          transform: translateX(-50%) translateY(-50%) rotate(45deg);
  -webkit-transform-origin: center center;
          transform-origin: center center;
}

.modal-close:before {
  height: 2px;
  width: 50%;
}

.modal-close:after {
  height: 50%;
  width: 2px;
}

.modal-close:hover, .modal-close:focus {
  background-color: rgba(10, 10, 10, 0.3);
}

.modal-close:active {
  background-color: rgba(10, 10, 10, 0.4);
}

.modal-close.is-small {
  height: 16px;
  width: 16px;
}

.modal-close.is-medium {
  height: 24px;
  width: 24px;
}

.modal-close.is-large {
  height: 32px;
  width: 32px;
}

.modal-card {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  max-height: calc(100vh - 40px);
  overflow: hidden;
}

.modal-card-head,
.modal-card-foot {
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  background-color: whitesmoke;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -webkit-box-pack: start;
      -ms-flex-pack: start;
          justify-content: flex-start;
  padding: 20px;
  position: relative;
}

.modal-card-head {
  border-bottom: 1px solid #dbdbdb;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.modal-card-title {
  color: #363636;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  -ms-flex-negative: 0;
      flex-shrink: 0;
  font-size: 1.5rem;
  line-height: 1;
}

.modal-card-foot {
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top: 1px solid #dbdbdb;
}

.modal-card-foot .button:not(:last-child) {
  margin-right: 10px;
}

.modal-card-body {
  -webkit-overflow-scrolling: touch;
  background-color: white;
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  -ms-flex-negative: 1;
      flex-shrink: 1;
  overflow: auto;
  padding: 20px;
}

.modal {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  display: none;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  overflow: hidden;
  position: fixed;
  z-index: 200;
}

.modal.is-active {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}*/
</style>
